import { CommonHelperFunctions } from "@kuika/kuika-cl-model";
import Axios, { AxiosResponse } from "axios";
import { IOnboardingFolder, IOnboardingTooltipItem } from "../models/onboarding-tooltip";
import { KMainFunctions } from "../shared/utility/main-functions";

const backendUrl = CommonHelperFunctions.GetBackendUrl();

export const OnboardingTooltipService = {
  // Throws on failure: callers (TanStack Query for the designer, try/catch in the settings
  // panel) decide whether to retry or surface it. Swallowing into [] made a single failed boot
  // read indistinguishable from "no tooltips" for the rest of the session.
  getTooltips: async (): Promise<IOnboardingTooltipItem[]> => {
    const response: AxiosResponse<IOnboardingTooltipItem[]> = await Axios.get<IOnboardingTooltipItem[]>(
      `${backendUrl}/OnboardingTooltip/tooltips`
    );
    return response.data || [];
  },

  saveTooltip: async (tooltip: Partial<IOnboardingTooltipItem>): Promise<IOnboardingTooltipItem | null> => {
    try {
      const response = await Axios.post<IOnboardingTooltipItem>(`${backendUrl}/OnboardingTooltip/tooltips`, tooltip);
      return response.data;
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  },

  deleteTooltip: async (id: string): Promise<void> => {
    try {
      await Axios.delete(`${backendUrl}/OnboardingTooltip/tooltips/${id}`);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
    }
  },

  toggleDraft: async (id: string): Promise<IOnboardingTooltipItem | null> => {
    try {
      const response = await Axios.post<IOnboardingTooltipItem>(
        `${backendUrl}/OnboardingTooltip/tooltips/${id}/toggle-draft`
      );
      return response.data;
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  },

  duplicateTooltip: async (id: string): Promise<IOnboardingTooltipItem | null> => {
    try {
      const response = await Axios.post<IOnboardingTooltipItem>(
        `${backendUrl}/OnboardingTooltip/tooltips/${id}/duplicate`
      );
      return response.data;
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  },

  getFolders: async (): Promise<IOnboardingFolder[]> => {
    try {
      const response = await Axios.get<IOnboardingFolder[]>(`${backendUrl}/OnboardingTooltip/folders`);
      return response.data || [];
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return [];
    }
  },

  saveFolder: async (folder: Partial<IOnboardingFolder>): Promise<IOnboardingFolder | null> => {
    try {
      const response = await Axios.post<IOnboardingFolder>(`${backendUrl}/OnboardingTooltip/folders`, folder);
      return response.data;
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  },

  deleteFolder: async (id: string): Promise<void> => {
    try {
      await Axios.delete(`${backendUrl}/OnboardingTooltip/folders/${id}`);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
    }
  },

  reorderFolders: async (folderIds: string[]): Promise<void> => {
    try {
      await Axios.post(`${backendUrl}/OnboardingTooltip/folders/reorder`, folderIds);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
    }
  }
};

export default OnboardingTooltipService;
